import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const HtmlBlogList = () => {
    const BlogList = [
        {
            blogImg: '/assets/images/blog-1.png',
            blogTitle: 'Software Technology Trends in 2024: A Glance At The Future...',
            blogBtn: 'Read More',
            path: '/blog-detail'
        },
        {
            blogImg: '/assets/images/blog-2.png',
            blogTitle: 'The Power of Smart Warehouse Management System in 2024',
            blogBtn: 'Read More',
            path: '/blog-warehouse'
        },
        {
            blogImg: '/assets/images/blog-3.png',
            blogTitle: 'Unlocking Growth for B2B Enterprises with Performance',
            blogBtn: 'Read More',
            path: '/blog-growth'
        },
        {
            blogImg: '/assets/images/blog-1.png',
            blogTitle: 'Software Technology Trends in 2024: A Glance At The Future...',
            blogBtn: 'Read More',
            path: '/blog-detail'
        },
        {
            blogImg: '/assets/images/blog-2.png',
            blogTitle: 'The Power of Smart Warehouse Management System in 2024',
            blogBtn: 'Read More',
            path: '/blog-warehouse'
        },
        {
            blogImg: '/assets/images/blog-3.png',
            blogTitle: 'Unlocking Growth for B2B Enterprises with Performance',
            blogBtn: 'Read More',
            path: '/blog-growth'
        }
    ]

    return (
        <section className='blog_section'>
            {/* Blog List Banner */}
            <section className='about-page'>
                <div className='blog-list-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center'>
                        
                            <div className='col-lg-12' data-aos="fade-up" data-aos-duration="2000">
                                <div className='tech-content text-center ms-0'>
                                    <h2 className='mb-0'>Tags: HTML </h2>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>

            <section className='blog-list-padding'>
                <Container>
                    <Row>
                        {
                            BlogList.map((blogCard,index)=>(
                                <div key={index} className='col-lg-4 col-md-6 col-sm-6 mb-30'>
                                    <div className='item blog-list-item'>
                                        <Link to={blogCard.path}>
                                            <div className='blog-card-list'>
                                                <div className='blog-img blog-img-list'>
                                                    <img src={blogCard.blogImg} alt="Blog-Image" />
                                                </div>
                                                <div className='body-blog'>
                                                    <h3>{blogCard.blogTitle}</h3>
                                                    <button className='read-more'>{blogCard.blogBtn}</button>
                                                </div>
                                            </div>
                                        
                                        </Link>
                                    </div>
                                </div>
                            ))
                        }
                    </Row>
                </Container>
            </section>
            
        </section>
    )
}

export default HtmlBlogList
